import { Form, Row, Upload } from "antd";
import { useMemo } from "react";
import { usePermissions } from "../../../lib/hooks/usePermissions";
import { useUploadFile } from "../../../lib/hooks/useUploadFile";
import { useDownload } from "../hooks/useDownload";
import { useUploadFileRule } from "../../../lib/hooks/useUploadFileRule";
import { UploadRow } from "./UploadRow";

type AttachmentsProps = {
  mailingType: 1 | 2 | 3;
  status: number | undefined;
  canceled: boolean;
  setIsSaving: React.Dispatch<React.SetStateAction<boolean>>;
};

export const Attachments = ({ mailingType, status, canceled, setIsSaving }: AttachmentsProps) => {
  const { hasAccessByController } = usePermissions("MailingEmails");

  const { onDownload } = useDownload();

  const showRemoveIcon: boolean = useMemo(() => {
    if (canceled) {
      return true;
    }
    if (mailingType === 1) {
      return hasAccessByController("SaveAndSend") && !(status === 3 || status === 2 || status === 10);
    }

    return false;
  }, [canceled, mailingType, hasAccessByController, status]);

  const showUploadListProps = useMemo(() => ({ showDownloadIcon: true, showRemoveIcon }), [showRemoveIcon]);

  const { upload } = useUploadFile(2, setIsSaving);

  const { rule } = useUploadFileRule();

  return (
    <Row className="position-relative">
      <Form.Item
        label="Attachments"
        name="fileList"
        className="mb-2 w-100"
        valuePropName="fileList"
        getValueFromEvent={(e) => e.fileList}
        rules={rule}
      >
        <Upload
          listType="picture"
          customRequest={upload}
          previewFile={async () => ""}
          showUploadList={showUploadListProps}
          onDownload={onDownload}
          disabled={false}
        >
          {(mailingType === 1 || canceled) && <UploadRow />}
        </Upload>
      </Form.Item>
    </Row>
  );
};
